import { DEFAULT_VIDEO_CAPTURE_FPS, DEFAULT_VIDEO_CAPTURE_HEIGHT, DEFAULT_VIDEO_CAPTURE_WIDTH, } from "gather-video-common/dist/src/public/settings";
import { PeerManagerEvent } from "../PeerManagerEvent";
import { debounce } from "lodash";
const LOW_FPS_THRESHOLD = { width: 160, height: 90 };
const LOW_VIDEO_FPS = DEFAULT_VIDEO_CAPTURE_FPS / 2;
const CONSTRAINTS_360P = { width: 640, height: 360 };
const USE_360P_THRESHOLD_DIMS = { width: 320, height: 180 };
export class LocalVideoQualityManager {
    pm;
    device;
    enabled = false;
    usages = [];
    constructor(pm, device) {
        this.pm = pm;
        this.device = device;
        pm.addEventListener(PeerManagerEvent.AllowedChange, this.recalcLocalVideoConstraints);
    }
    enable() {
        this.enabled = true;
        this.recalcLocalVideoConstraints();
    }
    addLocalVideoUsage(width, height) {
        const dims = { width, height };
        this.usages.push(dims);
        this.recalcLocalVideoConstraints();
        return () => {
            this.usages = this.usages.filter((x) => x !== dims);
            this.recalcLocalVideoConstraints();
        };
    }
    allUsagesBelowThreshold({ width, height }) {
        if (this.usages.length === 0)
            return false;
        return this.usages.every(({ width: w, height: h }) => w <= width && h <= height);
    }
    recalcLocalVideoConstraints = debounce(() => {
        if (!this.enabled || this.device.isMuted())
            return;
        const constraints = this.device.getCurrentConstraints();
        if (!constraints)
            return;
        if (Object.keys(this.pm.allowed).length === 0) {
            if (this.allUsagesBelowThreshold(LOW_FPS_THRESHOLD)) {
                constraints.frameRate = LOW_VIDEO_FPS;
            }
            if (this.allUsagesBelowThreshold(USE_360P_THRESHOLD_DIMS)) {
                constraints.width = { max: DEFAULT_VIDEO_CAPTURE_WIDTH, ideal: CONSTRAINTS_360P.width };
                constraints.height = {
                    max: DEFAULT_VIDEO_CAPTURE_HEIGHT,
                    ideal: CONSTRAINTS_360P.height,
                };
            }
        }
        this.device.updateConstraints("video", constraints);
    }, 50, { trailing: true });
}
//# sourceMappingURL=LocalVideoQualityManager.js.map